

// yorum

export class M_USER {
    ID: number;
    Name:string;
    Sifre:number;
    Type:number;
    YetTip:number;


   
}

export class USER_TABLE{
    static TableQuery(){
        var query =  "CREATE TABLE IF NOT EXISTS M_USER " +
        "(" +
        "ID INTEGER PRIMARY KEY ASC," +
       
        "Name text," +
        "Sifre text," +
        "Type text," +
        
        "YetTip text";
        return query;
    }
}




// WEBPACK FOOTER //
// ./src/models/M_USER.ts